import { PropsWithChildren, useCallback, useState } from "react";

import { Paper, Tabs, makeStyles } from "@material-ui/core";

const useTabsStyles = makeStyles({
    indicator: {
        backgroundColor: "#297A1D",
    },
});

interface TabBarProps {
    index: number;
}

export const TabBar = (props: PropsWithChildren<TabBarProps>) => {
    const tabsClasses = useTabsStyles();

    const { index, children } = props;

    const [value, setValue] = useState(index);
    const onChange = useCallback((_: any, newValue: number) => {
        setValue(newValue);
    }, []);

    return (
        <Paper square>
            <Tabs value={value} onChange={onChange} aria-label="faner" variant="scrollable" scrollButtons="on" classes={tabsClasses}>
                {children}
            </Tabs>
        </Paper>
    );
}
